import React, { ReactNode } from "react";

interface SummaryRowProps {
  label: string;
  value: ReactNode;
}

const SummaryRow: React.FC<SummaryRowProps> = ({ label, value }) => {
  return (
    <div className="flex items-center">
      <p className="w-[180px]">{label}</p>
      <p className="w-4 text-center">:</p>
      <p className="flex-1 text-right text-[#D70015]">{value}</p>
    </div>
  );
};

export default SummaryRow;
